import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import {
  STORE_VISIBILITY_VALUES,
  getStoreVisibilityLabel,
} from '../../context-api/api-services/StoreManagement.service';
import {
  storeManagementMenuPaperSx as menuPaperSx,
  storeManagementMenuItemSx as menuItemSx,
  storeManagementOutlinedSelectSx as outlinedSelectSx,
} from '../../utils/storeManagementSelectSx';
import {
  COLORS,
  STATUS_FILTER_ALL,
  STORE_VISIBILITY_FILTER_ALL,
  STATUS_OPTIONS,
  outlinedSearchSx,
} from './storeManagementConstants';

export function StoreManagementFilterBar({
  storeNameSearch,
  onStoreNameSearchChange,
  statusFilter,
  onStatusFilterChange,
  storeVisibilityFilter,
  onStoreVisibilityFilterChange,
}) {
  return (
    <Box
      sx={{
        px: { xs: 2.5, sm: 4 },
        py: 2,
        bgcolor: '#fafbfc',
        borderBottom: `1px solid ${COLORS.border}`,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <TextField
        size="small"
        label="Search stores"
        placeholder="Type store name…"
        value={storeNameSearch}
        onChange={(e) => onStoreNameSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: COLORS.muted, fontSize: 18 }} />
            </InputAdornment>
          ),
        }}
        sx={{ flex: '1 1 200px', maxWidth: 320, ...outlinedSearchSx }}
      />
      <FormControl
        size="small"
        sx={{ minWidth: { xs: '100%', sm: 160 }, ...outlinedSelectSx }}
      >
        <InputLabel id="store-status-filter-label">Status</InputLabel>
        <Select
          labelId="store-status-filter-label"
          label="Status"
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          MenuProps={{ PaperProps: { sx: menuPaperSx } }}
        >
          {STATUS_OPTIONS.map((opt) => (
            <MenuItem key={opt} value={opt} sx={menuItemSx}>
              {opt === STATUS_FILTER_ALL ? 'All statuses' : opt}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl
        size="small"
        sx={{ minWidth: { xs: '100%', sm: 188 }, ...outlinedSelectSx }}
      >
        <InputLabel id="store-visibility-status-filter-label">Store visibility</InputLabel>
        <Select
          labelId="store-visibility-status-filter-label"
          label="Store visibility"
          value={storeVisibilityFilter}
          onChange={(e) => onStoreVisibilityFilterChange(e.target.value)}
          MenuProps={{ PaperProps: { sx: menuPaperSx } }}
        >
          <MenuItem value={STORE_VISIBILITY_FILTER_ALL} sx={menuItemSx}>
            All
          </MenuItem>
          {STORE_VISIBILITY_VALUES.map((v) => (
            <MenuItem key={v} value={v} sx={menuItemSx}>
              {getStoreVisibilityLabel(v)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
